import { RequestError } from '@/requestErrorConfig';
import { ApiProblemError } from '@/services/business/client';

export function shouldRetryQuery(failureCount: number, error: unknown) {
  if (failureCount >= 1) return false;

  if (error instanceof ApiProblemError) {
    return error.status >= 500;
  }

  if (error instanceof RequestError) {
    return error.response ? error.response.status >= 500 : Boolean(error.request);
  }

  return false;
}
